var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#059ff5",
    d: "M43 21.5a21.5 21.5 0 1 1-43.01-.01A21.5 21.5 0 0 1 43 21.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 50,
    d: "M29.85 17.23l.01.56C29.86 23.46 25.53 30 17.6 30c-2.43 0-4.7-.71-6.6-1.93a8.71 8.71 0 0 0 6.38-1.78 4.3 4.3 0 0 1-4.03-2.98 4.24 4.24 0 0 0 1.95-.07 4.3 4.3 0 0 1-3.46-4.21v-.05c.58.32 1.25.51 1.95.54a4.32 4.32 0 0 1-1.33-5.73c2.12 2.59 5.3 4.3 8.88 4.48a4.3 4.3 0 0 1 7.34-3.91c.98-.2 1.91-.55 2.74-1.05a4.29 4.29 0 0 1-1.9 2.38 8.5 8.5 0 0 0 2.48-.68 8.73 8.73 0 0 1-2.15 2.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.86a368d3dd733fd1da7387fede623068.svg";
export { ForwardRef as ReactComponent };